import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AccordionItem,
  AccordionItemHeader,
  AccordionItemPanel,
} from 'src/components/common/Accordion';
import OrgTree from 'src/components/common/OrgTree';
import type { OrgTreeState } from 'src/components/common/OrgTree/types';
import { useDashboardContext } from 'src/components/dashboard/DashboardContext';

interface OrgTreeFilterProps {
  itemName: string;
  orgTreeState: OrgTreeState;
  disableOrgUnitSelectionBasedOnStatus?: boolean;
}

const OrgTreeFilter: FC<OrgTreeFilterProps> = ({
  itemName,
  orgTreeState,
  disableOrgUnitSelectionBasedOnStatus,
}) => {
  const { t } = useTranslation('report');
  const { orgTreeMode } = useDashboardContext();

  return (
    <AccordionItem itemName={itemName} aria-label={t('sidebar.title')}>
      <AccordionItemHeader headline={t('sidebar.title')} />

      <AccordionItemPanel>
        <OrgTree
          checkboxMode={orgTreeMode}
          orgTreeState={orgTreeState}
          disableOrgUnitSelectionBasedOnStatus={
            disableOrgUnitSelectionBasedOnStatus
          }
        />
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default OrgTreeFilter;
